import { render, staticRenderFns } from "./JtReport.vue?vue&type=template&id=ba302140&scoped=true&"
import script from "./JtReport.vue?vue&type=script&lang=js&"
export * from "./JtReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba302140",
  null
  
)

export default component.exports